import { useInjection } from 'inversify-react';
import { observer } from 'mobx-react-lite';
import { ReactElement, useEffect } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import { Home } from '../../../routes/config/Home';
import { DatasetNameForm } from '../components/DatasetNameForm';
import { ICreateDatasetService } from '../createDataset.service';

export const CreateDatasetContainer = observer((): ReactElement => {
  const createDatasetService = useInjection(ICreateDatasetService.$);

  const { datasetDraftId, workspaceId } = useParams<{ datasetDraftId?: string; workspaceId: string }>();
  const history = useHistory();

  useEffect(() => {
    if (!datasetDraftId) {
      const draftId = createDatasetService.initNewDraft();
      const path = Home.Datasets.Create.withParams({ datasetDraftId: draftId, workspaceId: workspaceId });
      history.push(path);
    }
  }, []);

  const { draft } = createDatasetService.datasetsDraftStore;
  if (!draft) {
    return <div />;
  }

  return (
    <DatasetNameForm
      name={draft.name}
      description={draft.description}
      onNameChange={async (val) => {
        await createDatasetService.changeDraftNameAsync(val);
      }}
      onDescriptionChange={(desc) => {
        createDatasetService.changeDraftDescription(desc);
      }}
      nameStatus={draft.nameStatus}
      externalStatus={draft.externalStatus}
      author={draft.author}
      onAuthorChange={(autor) => {
        createDatasetService.changeDraftAuthor(autor);
      }}
      termsOfUse={draft.termsOfUse}
      onTermsOfUseChange={(name) => {
        createDatasetService.changeDraftTermsOfUse(name);
      }}
    />
  );
});
